module.exports = __webpack_public_path__ + "img/wand-icon.f71c1e1.png";